import React from 'react';
import styled from 'styled-components';
import Icon from '../../../../components/Icon';

const Container = styled.div`
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors['white-two']};
  margin-top: 40px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px 32px 30px;

  hr {
    width: 100%;
    opacity: 0.2;
    background-color: #1f2b37;
    height: 1px;
    border: none;
  }
`;

const Logo = styled.div`
  font-size: 7em;
  opacity: 0.1;
  height: 110px;
`;

const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.oswald};
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-transform: uppercase;

  span {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Section = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: normal;
  opacity: 1;
  span {
    color: ${(props) => props.theme.colors['dark']};
  }

  b {
    font-weight: bold;
  }
`;

const WxrCms = (props) => (
  <Container>
    <Wrapper>
      <Header>
        <Title>{props.title}</Title>
        <Logo>
          <Icon icon={props.logo} />
        </Logo>
      </Header>
      <Section>{props.firstSection}</Section>
      <hr />
      <Section>{props.secondSection}</Section>
    </Wrapper>
  </Container>
);

export default WxrCms;
